import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import { X } from "lucide-react"; // or any icon library you use
import CloseIcon from "@mui/icons-material/Close";

toast.configure({
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "light",
  CloseIcon: CloseIcon,
  // Responsive toast configuration for web
  style: {
    width: "min(520px, 88vw)", 
    minWidth: "200px", 
    maxWidth: "90vw", 
    height: "auto", 
    minHeight: "72px", 
    borderRadius: "8px", 
    fontSize: "14px",
    lineHeight: "20px",
    padding: "18px 18px", 
    margin: "10px auto", 
    boxSizing: "border-box",
  },
  closeButton: ({ closeToast }) => (
    <CloseIcon
      onClick={closeToast}
      style={{ cursor: "pointer", color: "#FFFFFF", fontSize: "18px" }}
    />
  ),
});

export default toast;
